export function getPersonaIds(personas) {
  return personas.map((persona) => persona.id);
}
